// extracted by mini-css-extract-plugin
module.exports = {"modalContent":"UpgradeEpcsModal_modalContent__LWSXp","modalForm":"UpgradeEpcsModal_modalForm__3M-Iq","modalFooter":"UpgradeEpcsModal_modalFooter__ZT_P7"};